<div class="video-request"
     *ngIf="request">
    <div class="row">
        <div class="col col-sm-12 col-md-6 col-lg-6">
            <div class="panel panel-primary request-panel">
                <div class="panel-heading">
                    <strong data-cy="video-request-name">{{ request.requestName }}</strong>
                </div>
                <div class="panel-body">
                    <table>
                        <tbody>
                        <tr>
                            <th>Status</th>
                            <td colspan="4">                                
                                <span data-cy="video-request-status" class="label {{ (request.purgedIn <= 0) ? 'label-danger' : request.status === 'In Progress' && request.truckIsOffline ? 'label-gray' : request.status | appStatusLabel }}">
                                    {{ (request.purgedIn <= 0) ? 'Expired' : (request.status === 'In Progress' && request.truckIsOffline ? 'Offline' : request.status.replace('Truck', 'Unit')) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Location</th>
                            <td data-cy="video-request-location" colspan="4">{{ request.location }}</td>
                        </tr>
                        <tr>
                            <th>Video Date</th>
                            <td data-cy="video-request-date" colspan="4">{{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentDateFormatLong' }}</td>
                        </tr>
                        <tr>
                            <th>From</th>
                            <td class="nowrap">
                                    <span data-cy="video-request-from" title="{{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentTimeFormatLong' | lowercase }}">
                                        {{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentTimeFormatMedium' | lowercase }}
                                    </span>
                            </td>
                            <th>To</th>
                            <td class="nowrap">
                                    <span data-cy="video-request-to" title="{{ request.videoTo | appIsoDateStringMomentFromConfig: 'momentTimeFormatLong' | lowercase }}">
                                        {{ request.videoTo | appIsoDateStringMomentFromConfig: 'momentTimeFormatMedium' | lowercase }}
                                    </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Site</th>
                            <td data-cy="video-request-site-number">{{ request.siteNumber }}</td>
                            <th data-cy="video-request-unit">Unit</th>
                            <td data-cy="video-request-truck-number">{{ request.truckNumber }}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <th>Expires</th>
                            <td colspan="4"
                                [ngSwitch]="request.purgedInUnit">
                                <span *ngSwitchCase="'hours'">
                                    <span *ngIf="request.purgedIn <= 0" class="label label-danger">Expired</span>
                                    <span *ngIf="request.purgedIn > 0">{{ request.purgedIn }} {{ request.purgedInUnit }}</span>
                                </span>
                                <span *ngSwitchDefault>
                                    <span *ngIf="request.purgedIn <= 0" class="label label-danger">Expired</span>
                                    <span data-cy="video-request-expires" class="label label-info"
                                          *ngIf="request.purgedIn > 1 && !request.hasTruckResponded"
                                          title="Requests will be purged if the unit hasn't responded within this period">
                                        {{ request.purgedIn }} {{ request.purgedInUnit }}
                                    </span>
                                    <span data-cy="video-request-success-expires" class="label label-success"
                                          *ngIf="request.purgedIn > 7  && request.hasTruckResponded">
                                        {{ request.purgedIn }} {{ request.purgedInUnit }}
                                    </span>
                                    <span data-cy="video-request-warning-expires" class="label label-warning"
                                          *ngIf="request.purgedIn <= 7 && request.purgedIn > 0 && request.hasTruckResponded">
                                        {{ request.purgedIn }} {{ request.purgedInUnit }}
                                    </span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Cameras</th>
                            <td colspan="4">
                                <ng-container *ngFor="let cameraType of request.cameraTypes">
                                    <span data-cy="video-request-camera-type" class="camera"> {{ cameraType }}</span>
                                </ng-container>
                            </td>
                        </tr>
                        <tr>
                            <th>Device</th>
                            <td data-cy="video-request-device-id" colspan="4">{{ request.deviceId }}</td>
                        </tr>
                        <tr>
                            <th>Request Date</th>
                            <td colspan="4">
                                    <span data-cy="request-date" title="{{ request.createdAt | appIsoDateStringMomentFromConfig: 'momentDateAndTimeFormatTitle' }}">
                                            {{ request.createdAt | appIsoDateStringMomentFromConfig: 'momentDateFormatLong' }}
                                        {{ hoursAgo }}
                                    </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Reason</th>
                            <td data-cy="video-request-notes" class="video-request-note" colspan="4">{{ request.notes }}</td>
                        </tr>
                        <tr>
                            <th>Request Id</th>
                            <td data-cy="video-request-id" colspan="4">{{ request.requestId }} ({{ request.vrrId }})</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col col-sm-12 col-md-6 col-lg-6"
             *ngFor="let video of request.videos">
            <div class="panel panel-info video-panel">
                <div [attr.data-cy]="'video-' + video.camera"
                     class="panel-heading">
                    <strong data-cy="video-camera">{{ video.camera }}</strong>
                    <div class="status m-t-10"
                         [ngSwitch]="video.status">
                        <span data-cy="unavailable" 
                              class="pull-right text-danger"
                              *ngSwitchCase="'TruckRespondedWithNoVideo'">Unavailable</span>
                        <span data-cy="rejected"
                              class="pull-right text-danger"
                              *ngSwitchCase="'Rejected'">Rejected</span>
                        <a [attr.data-cy]="'download-' + video.camera"
                           class="pull-right btn btn-success"
                           (click)="onDownload($event, video)"
                           download
                           href="{{ video.highQualityVideoUri }}"
                           *ngIf="canDownload(video)">Download</a>
                        <button [attr.data-cy]="'reject-' + video.camera"
                                class="pull-right btn btn-danger btn-reject"
                                (click)="showRejectModal(video)"
                                data-toggle="modal"
                                data-target="#rejectModal"
                                *ngIf="canReject(video)"
                                type="button">
                            Reject
                        </button>
                    </div>
                </div>
                <div class="panel-body">
                    <div class="unavailable-video-status"
                         *ngIf="video.status !== 'Emailed'"
                         [ngSwitch]="video.status">
                        <span class="text-danger" *ngSwitchCase="'TruckRespondedWithNoVideo'">
                            No unit video for the {{ video.camera.toLowerCase() }} camera.
                        </span>
                        <span class="text-info" *ngSwitchCase="'Purged'">
                            The unit video for the {{ video.camera.toLowerCase() }} camera was purged.
                        </span>
                        <p class="text-info" *ngSwitchCase="'Rejected'">
                            The {{ video.camera.toLowerCase() }} camera video is {{ video.state.replace('Truck', 'Unit') }}...
                        </p>
                        <p class="text-info" *ngSwitchCase="'UploadingFailed'">
                            The {{ video.camera.toLowerCase() }} camera video {{ video.state.replace('Truck', 'Unit') }}...
                        </p>
                        <p class="text-info" *ngSwitchCase="'PublishingFailed'">
                            The {{ video.camera.toLowerCase() }} camera video {{ video.state.replace('Truck', 'Unit') }}...
                        </p>
                        <p *ngSwitchCase="'Rejected'"><i>"{{ video.rejectionReason }}"</i></p>
                        <span class="text-info in-progress" *ngSwitchDefault>
                            The {{ video.camera.toLowerCase() }} camera video is {{ video.state.replace('Truck', 'Unit') }}...
                        </span>
                    </div>
                    <video [attr.data-cy]="'video-preview-' + video.camera"
                           id="videoplayer_{{ video.assetId }}"
                           controls="controls"
                           controlsList="nodownload"
                           *ngIf="video.status === 'Emailed'"
                           (play)="onPlay(video, $event.target)"
                           (pause)="onPause(video, $event.target)"
                           (ended)="onEnded(video, $event.target)"
                           preload="none"
                           >
                        <source src="{{ video.highQualityVideoUri }}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="rejectVideoModalTitle">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 id="rejectVideoModalTitle">Reject Video</h4>
                </div>
                <div class="modal-body">
                    <p data-cy="enter-reason">Please enter the reason you are rejecting this video</p>
                    <textarea class="form-control"
                              id="reason"
                              name="reason"
                              [(ngModel)]="reason"
                              placeholder="e.g. Video too blurry..."
                              rows="5"></textarea>
                    <div data-cy="invalid-reason"
                         class="invalid-reason"
                         [hidden]="isReasonValid()">Please enter a valid reason</div>
                </div>
                <div class="modal-footer">
                    <button data-cy="cancel-reject" type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button data-cy="video-reject" type="button"
                            class="btn btn-warning"
                            (click)="reject()"
                            data-dismiss="modal"
                            [disabled]="!isReasonValid()">
                        Reject
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
